import { useDeviceType } from '../../../../responsive';
export const useColProps = props => {
  var _ref, _ref2, _ref3;
  const {
    xs,
    m,
    l,
    xsOffset,
    mOffset,
    lOffset,
    xsOffsetRight,
    mOffsetRight,
    lOffsetRight,
    xsHidden,
    mHidden,
    lHidden
  } = props;
  const device = useDeviceType();
  const cols = {
    desktop: (_ref = l !== null && l !== void 0 ? l : m) !== null && _ref !== void 0 ? _ref : xs,
    tablet: m !== null && m !== void 0 ? m : xs,
    phone: xs
  };
  const offsets = {
    desktop: (_ref2 = lOffset !== null && lOffset !== void 0 ? lOffset : mOffset) !== null && _ref2 !== void 0 ? _ref2 : xsOffset,
    tablet: mOffset !== null && mOffset !== void 0 ? mOffset : xsOffset,
    phone: xsOffset
  };
  const offsetsRight = {
    desktop: (_ref3 = lOffsetRight !== null && lOffsetRight !== void 0 ? lOffsetRight : mOffsetRight) !== null && _ref3 !== void 0 ? _ref3 : xsOffsetRight,
    tablet: mOffsetRight !== null && mOffsetRight !== void 0 ? mOffsetRight : xsOffsetRight,
    phone: xsOffsetRight
  };
  const hiddens = {
    desktop: lHidden,
    tablet: mHidden,
    phone: xsHidden
  };
  return {
    col: cols[device],
    offset: offsets[device],
    offsetRight: offsetsRight[device],
    hidden: hiddens[device]
  };
};